import styled from 'styled-components'

import Icon from '../Icon'
import Link from '../Link'
import Picture from '../Picture'

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 1.5rem;
  gap: 1.5rem;
  width: 100%;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`

export const AmountTag = styled.div`
  padding: 1.2rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Amount = styled.span`
  ${({ theme }) => theme.textStyles.textXSmallStrong};
  color: ${({ theme }) => theme.colors.ruby};
  //white-space: nowrap;
  word-break: break-word;
`

export const Name = styled.span<{ $isImportant?: boolean }>`
  color: ${({ theme }) => theme.colors.arapawa};
  ${({ theme }) => theme.textStyles.textLarge}

  @media print {
    ${({ theme }) => theme.textStyles.textSmall};
  }
`

export const Product = styled(Link)`
  display: flex;
  width: 100%;
  gap: 1rem;
  padding: 1rem;
  border-radius: 1rem;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.colors.pureWhite};

  @media print {
    display: none;
  }
`
export const ProductImage = styled(Picture)`
  display: flex;
  align-items: center;
  width: 7rem;
  height: 7rem;
  flex-shrink: 0;
`
export const ProductName = styled.div`
  ${({ theme }) => theme.textStyles.textSmallStrong};
  color: ${({ theme }) => theme.colors.arapawa};
  text-align: left;
`
export const Arrow = styled(Icon)`
  width: 2.8rem;
  height: 2.8rem;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.linen};
  padding: 0.6rem;
  border: 1px solid ${({ theme }) => theme.colors.greyChateau};
  border-radius: 100%;
  color: ${({ theme }) => theme.colors.bismark};
`
